import { API } from 'aws-amplify'
import { gql } from 'graphql-tag'

const getWorkspaceById = async (workspaceId) => {
  const { data, errors } = await API.graphql({
    query: GET_WORKSPACE_BY_ID_QUERY,
    variables: { id: workspaceId }
  })

  if (errors) throw errors
  return data?.getWorkspaceById
}

const GET_WORKSPACE_BY_ID_QUERY = gql`
  query GetWorkspaceById($id: ID!) {
    getWorkspaceById(id: $id) {
      id
      name
      description
      inviteId
      createdAt
      logo
      email
      twitterUsername
      websiteUrl
      communityUrl
      defaultUser {
        id
        firstName
        lastName
      }
      memberCollection {
        total
        items {
          createdAt
          id
          role
          user {
            id
            uid
            firstName
            lastName
            avatar
            email
            createdAt
          }
          createdAt
        }
      }
      tagCollection {
        items {
          id
          type
          name
          count
        }
        total
      }
    }
  }
`

export { GET_WORKSPACE_BY_ID_QUERY, getWorkspaceById }
